import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const PaymentCanceled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container py-8">
        <div className="max-w-2xl mx-auto">
          <Card className="text-center">
            <CardHeader className="pb-6">
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center">
                  <XCircle className="h-8 w-8 text-destructive" />
                </div>
              </div>
              <CardTitle className="text-2xl text-destructive">
                Paiement annulé
              </CardTitle>
              <CardDescription className="text-lg">
                Votre paiement a été annulé. Aucun montant n'a été débité.
              </CardDescription>
            </CardHeader>

            <CardContent className="space-y-6">
              {/* Information */}
              <div className="bg-yellow-50 p-4 rounded-lg text-left">
                <h3 className="font-semibold text-yellow-900 mb-2">Que s'est-il passé ?</h3>
                <p className="text-sm text-yellow-800">
                  Votre paiement a été interrompu ou annulé. Vos articles sont toujours dans votre panier 
                  et vos commandes restent en attente de paiement.
                </p>
              </div>

              {/* Options */}
              <div className="space-y-4">
                <h3 className="font-semibold">Que souhaitez-vous faire ?</h3>
                
                <div className="grid gap-3">
                  <Button 
                    className="w-full justify-start" 
                    onClick={() => navigate('/dashboard')}
                  >
                    <CreditCard className="mr-2 h-4 w-4" />
                    Réessayer le paiement
                  </Button>
                  
                  <Button 
                    variant="outline" 
                    className="w-full justify-start"
                    onClick={() => navigate('/products')}
                  >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Continuer mes achats
                  </Button>
                </div>
              </div>

              {/* Help */}
              <div className="bg-blue-50 p-4 rounded-lg text-left">
                <h3 className="font-semibold text-blue-900 mb-2">Besoin d'aide ?</h3>
                <div className="space-y-1 text-sm text-blue-800">
                  <p>• Vérifiez que votre carte est valide et a suffisamment de fonds</p>
                  <p>• Essayez un autre mode de paiement (Mobile Money)</p>
                  <p>• Contactez notre support si le problème persiste</p>
                </div>
              </div>

              <div className="pt-4">
                <Button variant="link">
                  Contacter le support client
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PaymentCanceled;